import { getPlayerModels as getPlayerModelsRequest } from '@/api/endpoints/getPlayerModels';
import { postSearchOrders } from '@/api/endpoints';
import { OrdersDB } from '@/db/repositories/OrdersRepo';
import { OrderSearchRequest } from '@/api/models';

export const searchOrders = async (request: OrderSearchRequest) => {
  const response = await postSearchOrders(request);
  return response;
};

export const getPlayerModels = async (playerId: number) => {
  const response = await getPlayerModelsRequest(playerId);
  return response;
};

export const refreshOrders = async (request: OrderSearchRequest) => {
  const response = await searchOrders(request);
  void OrdersDB.appendMissingOrders(response.results).catch((error) => {
    console.error('Could not cache refreshed orders:', error);
  });
  return response;
};
